import loadable from "@loadable/component";

import { routesUrlsData } from "@/data";

// Layouts
const BlankLayout = loadable(() => import("@/layouts/blank"));
const MainLayout = loadable(() => import("@/layouts/main"));
const AuthLayout = loadable(() => import("@/layouts/auth"));

// Module Routes
const AccountsListView = loadable(() => import("@/views/accounts"));
const AccountDetailsView = loadable(() => import("@/views/accounts/details"));

const DataSourcesListView = loadable(() => import("@/views/data-sources"));
const DataSourceDetailsView = loadable(() => import("@/views/data-sources/details"));
const DataSourceSetupView = loadable(() => import("@/views/data-sources/setup"));
const OfflineMappingDataSourceView = loadable(() => import("@/views/data-sources/offline-mapping"));

const ReconciliationsListView = loadable(() => import("@/views/reconciliations"));
const ReconciliationDetailsView = loadable(() => import("@/views/reconciliations/details"));
const ReconciliationAuditLogsView = loadable(() => import("@/views/reconciliations/audit-logs"));
const ReconciliationAuditLogDetailsView = loadable(() => import("@/views/reconciliations/audit-logs/details"));

const LedgerListView = loadable(() => import("@/views/ledger"));

const UsersListView = loadable(() => import("@/views/users"));
const ApiKeysListView = loadable(() => import("@/views/organizations/api-keys"));

// Generic Routes
const HomeView = loadable(() => import("@/views/home"));
const ProfileView = loadable(() => import("@/views/profile"));
const NotFoundView = loadable(() => import("@/views/not-found"));

// Auth Routes
const LoginView = loadable(() => import("@/views/auth/login"));
const ForgetPasswordView = loadable(() => import("@/views/auth/forget-password"));
const ResetPasswordView = loadable(() => import("@/views/auth/reset-password"));
const VerifyAccountView = loadable(() => import("@/views/auth/verify-account"));

// Admin Routes
const AdminHomeView = loadable(() => import("@/views/admin/home"));
const AdminOrganizationsListView = loadable(() => import("@/views/admin/organizations"));
const AdminOrganizationDetailsView = loadable(() => import("@/views/admin/organizations/details"));
const AdminDataSourcesListView = loadable(() => import("@/views/admin/data-sources"));
const AdminDataSourceDetailsView = loadable(() => import("@/views/admin/data-sources/details"));

export const Routes = [
    {
        children: [
            {
                element: <AccountsListView />,
                path: routesUrlsData.accounts,
            },
            {
                element: <AccountDetailsView />,
                path: `${routesUrlsData.accounts}/:id`,
            },
            {
                element: <DataSourcesListView />,
                path: routesUrlsData.dataSources.path,
            },
            {
                element: <DataSourceDetailsView />,
                path: `${routesUrlsData.dataSources.path}/:id`,
            },
            {
                element: <DataSourceSetupView />,
                path: routesUrlsData.dataSources.setup,
            },
            {
                element: <ReconciliationsListView />,
                path: routesUrlsData.reconciliations.path,
            },
            {
                element: <ReconciliationDetailsView />,
                path: `${routesUrlsData.reconciliations.path}/:id`,
            },
            {
                element: <ReconciliationAuditLogsView />,
                path: `${routesUrlsData.reconciliations.path}/:id/audit-logs`,
            },
            {
                element: <ReconciliationAuditLogDetailsView />,
                path: `${routesUrlsData.reconciliations.path}/:id/audit-logs/:auditLogId`,
            },
            {
                element: <LedgerListView />,
                path: routesUrlsData.ledger,
            },
            {
                element: <UsersListView />,
                path: routesUrlsData.users,
            },
            {
                element: <ApiKeysListView />,
                path: routesUrlsData.organization.apiKeys,
            },
            {
                element: <HomeView />,
                path: routesUrlsData.home,
            },
            {
                element: <ProfileView />,
                path: routesUrlsData.profile,
            },
            {
                element: <NotFoundView />,
                path: routesUrlsData.notFound,
            },
        ],
        element: <MainLayout />,
        path: routesUrlsData.home,
    },
    {
        children: [
            {
                element: <OfflineMappingDataSourceView />,
                path: routesUrlsData.dataSources.offlineMapping,
            },
        ],
        element: <BlankLayout />,
        path: routesUrlsData.home,
    },
    {
        children: [
            {
                element: <AdminHomeView />,
                path: routesUrlsData.admin.home,
            },
            {
                element: <AdminOrganizationsListView />,
                path: routesUrlsData.admin.organizations,
            },
            {
                element: <AdminOrganizationDetailsView />,
                path: `${routesUrlsData.admin.organizations}/:id`,
            },
            {
                element: <AdminDataSourcesListView />,
                path: routesUrlsData.admin.dataSources,
            },
            {
                element: <AdminDataSourceDetailsView />,
                path: `${routesUrlsData.admin.dataSources}/:id`,
            },
            {
                element: <NotFoundView />,
                path: routesUrlsData.notFound,
            },
        ],
        element: <MainLayout />,
        path: routesUrlsData.admin.home,
    },
    {
        children: [
            {
                element: <LoginView />,
                path: routesUrlsData.auth.login,
            },
            {
                element: <ForgetPasswordView />,
                path: routesUrlsData.auth.forgetPassword,
            },
            {
                element: <ResetPasswordView />,
                path: routesUrlsData.auth.resetPassword,
            },
            {
                element: <VerifyAccountView />,
                path: routesUrlsData.auth.inviteUser,
            },
        ],
        element: <AuthLayout />,
        path: routesUrlsData.auth.path,
    },
];
